module.exports = __webpack_public_path__ + "static/media/icon-js.f4874851.svg";